import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { FetchAllCountry, FetchCountry, FetchState, FetchAllState, FetchCity, FetchAllCity } from "../users/usersSlice";


const AddressDetails = ({ data, update, next, prev }) => {

    const dispatch = useDispatch();
    const [same, setSame] = useState(false);

    const StateData = useSelector(FetchAllState);
    const CitiesData = useSelector(FetchAllCity);

    const [form, setForm] = useState({
        currentAddress: "",
        currentCity: "",
        currentState: "",
        currentPin: "",
        permanentAddress: "",
        permanentCity: "",
        permanentState: "",
        permanentPin: "",
        ...(data.address || {}),
    });


    /* Fetch States on Load */
    useEffect(() => {
        fetchStates();
    }, []);


    /* Fetch Cities when state changes */
    useEffect(() => {
        if (form.currentState) {
            fetchCities("current");
        }
    }, [form.currentState]);


    useEffect(() => {
        if (form.permanentState) {
            fetchCities("permanent");
        }
    }, [form.permanentState]);


    /* Same Address Logic */
    useEffect(() => {
        if (same) {
            setForm((prev) => ({
                ...prev,
                permanentAddress: prev.currentAddress,
                permanentCity: prev.currentCity,
                permanentState: prev.currentState,
                permanentPin: prev.currentPin,
            }));
        }
    }, [
        same,
        form.currentAddress,
        form.currentCity,
        form.currentState,
        form.currentPin,
    ]);


    const fetchStates = () => {
        const Body = {
            countryid: 1,
            name: "India",
        };
        dispatch(FetchState(Body));
    };


    const fetchCities = (type) => {

        const selectedState =
            StateData?.result?.find(
                (item) =>
                    item.name ===
                    (type === "current"
                        ? form.currentState
                        : form.permanentState)
            );

        if (selectedState) {
            const Body = {
                countryid: 1,
                stateid: selectedState.id,
                name: selectedState.name,
            };

            dispatch(FetchCity(Body));
        }
    };


    const handleChange = (e) => {

        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value,

            ...(name === "currentState" && { currentCity: "" }),
            ...(name === "permanentState" && { permanentCity: "" }),

        }));
    };


    const validate = () => {

        const fields = [
            { key: "currentAddress", msg: "Current address is required" },
            { key: "currentCity", msg: "Current city is required" },
            { key: "currentState", msg: "Current state is required" },
            { key: "currentPin", msg: "Current PIN is required" },
            { key: "permanentAddress", msg: "Permanent address is required" },
            { key: "permanentCity", msg: "Permanent city is required" },
            { key: "permanentState", msg: "Permanent state is required" },
            { key: "permanentPin", msg: "Permanent PIN is required" },
        ];

        for (let field of fields) {
            if (!form[field.key]) {
                toast.error(field.msg);
                return false;
            }
        }

        if (form.currentPin.length !== 6) {
            toast.error("Current PIN must be 6 digits");
            return false;
        }

        if (form.permanentPin.length !== 6) {
            toast.error("Permanent PIN must be 6 digits");
            return false;
        }

        return true;
    };


    const handleNext = () => {
        const isValid = validate();
        if (!isValid) return;

        update("address", form);
        next();
    };


    return (

        <div>

            <h3 className="text-xl font-semibold mb-4">
                Address Details
            </h3>


            <div className="space-y-6">

                {/* Current Address */}
                <div className="border rounded-lg p-4">

                    <h4 className="font-semibold mb-3">
                        Current Address
                    </h4>

                    <div className="grid grid-cols-2 gap-4">

                        <div className="col-span-2">
                            <label>
                                Address <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                name="currentAddress"
                                value={form.currentAddress}
                                onChange={handleChange}
                                className="input w-full"
                            />
                        </div>





                        {/* State */}
                        <div>
                            <label>
                                State <span className="text-red-500">*</span>
                            </label>

                            <select
                                name="currentState"
                                value={form.currentState}
                                onChange={handleChange}
                                className="input w-full"
                            >

                                <option value="">
                                    Select State
                                </option>

                                {StateData?.result?.map((state) => (
                                    <option
                                        key={state.id}
                                        value={state.name}
                                    >
                                        {state.name}
                                    </option>
                                ))}

                            </select>

                        </div>
                        {/* City */}
                        <div>
                            <label>
                                City <span className="text-red-500">*</span>
                            </label>

                            <select
                                name="currentCity"
                                value={form.currentCity}
                                onChange={handleChange}
                                className="input w-full"
                            >

                                <option value="">
                                    Select City
                                </option>

                                {CitiesData?.result?.map((city) => (
                                    <option
                                        key={city.id}
                                        value={city.id}
                                    >
                                        {city.cityName}
                                    </option>
                                ))}

                            </select>

                        </div>


                        <div>
                            <label>
                                PIN Code <span className="text-red-500">*</span>
                            </label>

                            <input
                                name="currentPin"
                                maxLength="6"
                                value={form.currentPin}
                                onChange={handleChange}
                                className="input w-full"
                            />

                        </div>

                    </div>

                </div>



                {/* Same Address */}
                <div className="flex items-center gap-2">

                    <input
                        type="checkbox"
                        checked={same}
                        onChange={() => setSame(!same)}
                    />

                    <label>
                        Permanent address same as current
                    </label>

                </div>



                {/* Permanent Address */}
                <div className="border rounded-lg p-4">

                    <h4 className="font-semibold mb-3">
                        Permanent Address
                    </h4>

                    <div className="grid grid-cols-2 gap-4">

                        <div className="col-span-2">
                            <label>
                                Address <span className="text-red-500">*</span>
                            </label>

                            <textarea
                                name="permanentAddress"
                                value={form.permanentAddress}
                                onChange={handleChange}
                                className="input w-full"
                                disabled={same}
                            />

                        </div>


                        {/* Permanent City */}




                        {/* Permanent State */}
                        <div>

                            <label>
                                State <span className="text-red-500">*</span>
                            </label>

                            <select
                                name="permanentState"
                                value={form.permanentState}
                                onChange={handleChange}
                                className="input w-full"
                                disabled={same}
                            >

                                <option value="">
                                    Select State
                                </option>

                                {StateData?.result?.map((state) => (
                                    <option
                                        key={state.id}
                                        value={state.name}
                                    >
                                        {state.name}
                                    </option>
                                ))}

                            </select>

                        </div>
                        <div>

                            <label>
                                City <span className="text-red-500">*</span>
                            </label>

                            <select
                                name="permanentCity"
                                value={form.permanentCity}
                                onChange={handleChange}
                                className="input w-full"
                                disabled={same}
                            >

                                <option value="">
                                    Select City
                                </option>

                                {CitiesData?.result?.map((city) => (
                                    <option
                                        key={city.id}
                                        value={city.id}
                                    >
                                        {city.cityName}
                                    </option>
                                ))}

                            </select>

                        </div>



                        <div>
                            <label>
                                PIN Code <span className="text-red-500">*</span>
                            </label>

                            <input
                                name="permanentPin"
                                maxLength="6"
                                value={form.permanentPin}
                                onChange={handleChange}
                                className="input w-full"
                                disabled={same}
                            />

                        </div>

                    </div>

                </div>

            </div>



            <div className="mt-6 flex justify-between">

                <button
                    onClick={prev}
                    className="btn-secondary"
                >
                    Back
                </button>

                <button
                    onClick={handleNext}
                    className="btn-primary"
                >
                    Next
                </button>

            </div>

        </div>
    );
};

export default AddressDetails;